import { createRoot } from "@wordpress/element";
import App from "./components/App";

import "@/utils/i18n";

document
	.querySelectorAll(".wp-block-weather-marine-forecast-chart")
	.forEach((el) => {
		const root = el.querySelector(".marine-forecast-chart__app");
		if (root) {
			createRoot(root).render(<App />);
		}
	});
